/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateRemoteSessionClientForm,
  CreateRemoteSessionClientForm$Outbound,
  CreateRemoteSessionClientForm$outboundSchema,
} from "../components/createremotesessionclientform.js";

export type CreateRemoteSessionClientSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateRemoteSessionClientSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateRemoteSessionClientSecurity = {
  option1?: CreateRemoteSessionClientSecurityOption1 | undefined;
  option2?: CreateRemoteSessionClientSecurityOption2 | undefined;
};

export type CreateRemoteSessionClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createRemoteSessionClientForm: CreateRemoteSessionClientForm;
};

/** @internal */
export type CreateRemoteSessionClientSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateRemoteSessionClientSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateRemoteSessionClientSecurityOption1$Outbound,
    CreateRemoteSessionClientSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createRemoteSessionClientSecurityOption1ToJSON(
  createRemoteSessionClientSecurityOption1:
    CreateRemoteSessionClientSecurityOption1,
): string {
  return JSON.stringify(
    CreateRemoteSessionClientSecurityOption1$outboundSchema.parse(
      createRemoteSessionClientSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateRemoteSessionClientSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateRemoteSessionClientSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateRemoteSessionClientSecurityOption2$Outbound,
    CreateRemoteSessionClientSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createRemoteSessionClientSecurityOption2ToJSON(
  createRemoteSessionClientSecurityOption2:
    CreateRemoteSessionClientSecurityOption2,
): string {
  return JSON.stringify(
    CreateRemoteSessionClientSecurityOption2$outboundSchema.parse(
      createRemoteSessionClientSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateRemoteSessionClientSecurity$Outbound = {
  Option1?: CreateRemoteSessionClientSecurityOption1$Outbound | undefined;
  Option2?: CreateRemoteSessionClientSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateRemoteSessionClientSecurity$outboundSchema: z.ZodMiniType<
  CreateRemoteSessionClientSecurity$Outbound,
  CreateRemoteSessionClientSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateRemoteSessionClientSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateRemoteSessionClientSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createRemoteSessionClientSecurityToJSON(
  createRemoteSessionClientSecurity: CreateRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    CreateRemoteSessionClientSecurity$outboundSchema.parse(
      createRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type CreateRemoteSessionClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateRemoteSessionClientForm: CreateRemoteSessionClientForm$Outbound;
};

/** @internal */
export const CreateRemoteSessionClientRequest$outboundSchema: z.ZodMiniType<
  CreateRemoteSessionClientRequest$Outbound,
  CreateRemoteSessionClientRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createRemoteSessionClientForm: CreateRemoteSessionClientForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createRemoteSessionClientForm: "CreateRemoteSessionClientForm",
    });
  }),
);

export function createRemoteSessionClientRequestToJSON(
  createRemoteSessionClientRequest: CreateRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    CreateRemoteSessionClientRequest$outboundSchema.parse(
      createRemoteSessionClientRequest,
    ),
  );
}
